import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faScrewdriver } from '@fortawesome/free-solid-svg-icons';
import { LinearProgress } from '@mui/material';
import { withRouter } from 'react-router-dom';
import {
    createDataSource, createGridOptions, DataGrid, indexCellRenderer, LinkCellRenderer, TextFilterDefaults,
} from '../common/dataGrid/DataGrid';
import DataGridSelectFilter from '../common/dataGrid/DataGridSelectFilter';
import CommonContext, { ApiRoutes } from '../Common';
import { PageHeading, PageWrap } from '../common/forms/FormElements';
import { DepartmentForm } from './DepartmentForm';
import DataGridSelectFloatingFilter from '../common/dataGrid/DataGridSelectFloatingFilter';
import DataGridToolbar from '../common/dataGrid/DataGridToolbar';

class DepartmentIndex extends React.Component {
    static contextType = CommonContext;

    constructor(props) {
        super(props);

        this.DepartmentForm = React.createRef();

        this.state = {
            loading: true,
            roles: [],
            showDepartmentForm: false,
        };

        this.onAddDepartment = this.onAddDepartment.bind(this);
        this.onEditDepartment = this.onEditDepartment.bind(this);
        this.onDepartmentFormClosed = this.onDepartmentFormClosed.bind(this);
    }

    componentDidMount() { return this.populateState(); }

    onAddDepartment = () => {
        this.DepartmentForm.current.open();
    };

    onEditDepartment = (id) => {
        this.DepartmentForm.current.open(id);
    };

    onDepartmentFormClosed() {
        this.setState({ showDepartmentForm: false });
    }

    onDepartmentSaveCallback = (response) => {
        this.setState({ showDepartmentForm: false });
        this.context.setFormOpened(false);
        // Refresh grid
        this.state.gridApi.setDatasource(this.state.dataSource);
    };

    async populateState() {

        // Get grid defaults and handlers
        const gridOptions = createGridOptions(this);

        // Specify any custom components, filtering
        gridOptions.components = {
            selectFilter: DataGridSelectFilter,
            selectFloatingFilter: DataGridSelectFloatingFilter,
            nameRenderer: LinkCellRenderer,
        };

        // Provide column definitions
        gridOptions.columnDefs = [
            {
                flex: 0,
                width: 75,
                headerName: '',
                valueGetter: 'node.id',
                sortable: false,
                cellRenderer: indexCellRenderer,
            },
            {
                colId: 'Number',
                sortable: true,
                headerName: 'Number',
                field: 'departmentNumber',
                sort: { direction: 'asc', priority: 0 },
                filter: 'agTextColumnFilter',
                floatingFilter: true,
                filterParams: TextFilterDefaults,
                floatingFilterComponentParams: {
                    suppressFilterButton: true,
                },
                cellRenderer: 'nameRenderer',
                cellRendererParams: {
                    clicked: this.onEditDepartment,
                    nameField: 'departmentNumber',
                    idField: 'id',
                    title: 'View this Department',
                },
            },
            {
                colId: 'Description',
                sortable: true,
                headerName: 'Description',
                field: 'description',
                sort: { direction: 'asc', priority: 0 },
                filter: 'agTextColumnFilter',
                floatingFilter: true,
                filterParams: TextFilterDefaults,
                floatingFilterComponentParams: {
                    suppressFilterButton: true,
                }
            }
        ];

        // Create datasource.  Is reused and rebound on refresh from the state.
        const dataSource = createDataSource(ApiRoutes.department.search(), gridOptions);

        this.setState((state) => ({
            loading: false,
            gridOptions,
            dataSource,
        }));
    }

    render() {
        if (this.state.loading) return (<LinearProgress variant="indeterminate" color="secondary" />);

        const { rowData, gridOptions } = this.state;

        return (
            <PageWrap>
                <PageHeading>
                    <FontAwesomeIcon icon={faScrewdriver} className="mr-2 text-muted" />
                    <span>Departments</span>
                </PageHeading>
                <DataGridToolbar
                    entity="equipmenttype"
                    gridApi={this.state.gridApi}
                    dataSource={this.state.dataSource}
                    onAdd={this.onAddDepartment}
                    addLabel="Add Department"
                />
                <DataGrid
                    domLayout="normal"
                    rowData={rowData}
                    gridOptions={gridOptions}
                    gridStatus={this.state.gridStatus}
                />
                <DepartmentForm
                    ref={this.DepartmentForm}
                    equipmentType={this.state.selectedDepartment}
                    onClose={this.onDepartmentFormClosed}
                    show={this.state.showDepartmentForm}
                    onSaveCallback={this.onDepartmentSaveCallback}
                />
            </PageWrap>
        );
    }
}
export default withRouter(DepartmentIndex);
